const ALERTS_BASE = '/alerts'

export const PAGE_PATHS = {
  home: '/',
  overview: '/overview',
  gateFeed: '/gate-feed',
  gateFeedLegacy: '/gate-feed-legacy',
  checkIn: '/check-in',
  checkInHistory: '/check-in-history',
  help: 'https://navtrac.zendesk.com/hc/en-us',
  reports: '/reports',
  yardInventory: '/yard-inventory',
  reportsISR2305: '/reports/isr2305',
  isrv2: '/reports/isrv2',
  audits: '/audits',
  appointments: '/appointments',
  maintenance: '/maintenance',
  settings: '/settings',
  storybook: '/storybook/index.html',
  auth: '/auth',
  alertsEvents: `${ALERTS_BASE}/events`,
  alertsTriggers: `${ALERTS_BASE}/triggers`,
  analytics: '/analytics',
} as const
